import React from 'react';
import Alert from '../Alert';
import { Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  button: {
    marginLeft: theme.spacing(2),
  },
}));

const ErrorPage = ({ match, history }) => {
  const classes = useStyles();

  return (
    <Alert align="center">
      An error has occurred during authentication. Please contact customer
      support.
      <Button
        variant="outlined"
        color="primary"
        className={classes.button}
        onClick={() => history.push(`/${match.params.environment}`)}
      >
        Retry
      </Button>
    </Alert>
  );
};

export default ErrorPage;
